import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bganl3cn3b: FaireBrandEntity = {
  token: "b_bganl3cn3b",
  type: "brand",
  name: "VERLOOP | knits",
  avatarUrl:
    "https://cdn.faire.com/fastly/63cd7e679232cfa563e06b31e4a03c950958ba314b738534fc7e4a4b0f518288.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/4607614ff8e1685484568a87168b099ee30d82b60e1c65a29a2dfb2683d8e723.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/63cd7e679232cfa563e06b31e4a03c950958ba314b738534fc7e4a4b0f518288.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4607614ff8e1685484568a87168b099ee30d82b60e1c65a29a2dfb2683d8e723.jpeg",
  location: "Denton, MD, USA",
  minimumOrderDollars: 500,
  rating: 5,
  reviewCount: 68,
  isTopShop: true,
  isInsider: true,
  description:
    "VERLOOP is on a mission to reduce textile waste with playful, resourceful design. Made in a family-owned factory in the Philippines, VERLOOP knits repurpose deadstock material and bring feel-good color to everyday life.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:48.669Z",
    importedBy: "entity-db-cli",
  },
};
